import {
    Storage
} from "aws-amplify";
import crypto from "crypto";
import moment from "moment";

/**
 * バリデーション
 * @param {*} form
 */
export const validate_data = (form) => {
    let errors = {};

    if (form.title.length < 1) {
        errors.title = "入力してください";
    }

    if (form.contact.length < 1) {
        errors.contact = "入力してください";
    }

    if (form.address.length < 1) {
        errors.address = "入力してください";
    }

    if (form.tel.length < 1) {
        errors.tel = "入力してください";
    }

    if (form.website.length < 1) {
        errors.website = "入力してください";
    }

    if (form.sponsor.length < 1) {
        errors.sponsor = "入力してください";
    }

    if (form.images.length < 1) {
        errors.images = "画像が1枚も登録されていません";
    }

    if (form.publicationPeriod.length < 1) {
        errors.publicationPeriod = "選択してください";
    }

    return errors;
}

/**
 * ファイル形式のチェック
 * @param {*} file
 */
export const validate_file = (file) => {
    if (
        file.type != "image/jpeg" &&
        file.type != "image/gif" &&
        file.type != "image/png") {
        return false;
    }

    return true;
}

/**
 * 公開期間中かどうか判定
 * @param {*} form
 */
export const date_check = (form) => {
    let now = moment();
    return moment(form.publicationPeriod[0]) <= now &&
        now <= moment(form.publicationPeriod[1])
}

/**
 * 画像アップロード
 */
export const upload_image = (e, prefix, images) => {
    let files = e.target.files || e.dataTransfer.files;

    if (images.indexOf(prefix + create_filename(files[0])) != -1) {
        return {
            result: false,
            data: null,
            message: "すでに同じファイルをアップロード済みです。"
        }
    }

    if (!validate_file(files[0])) {
        return {
            result: false,
            data: null,
            message: ".jpg .gif .png のいずれかのファイルのみアップロード可能です。"
        }
    }

    return Storage.put(prefix + create_filename(files[0]), files[0], {
            level: "public"
        })
        .then(result => {
            return {
                result: true,
                data: result.key,
                message: "ファイルをアップロードしました"
            }
        })
        .catch(err => {
            console.log(err)
            return {
                result: false,
                data: err,
                message: "ファイルアップロードに失敗しました"
            }
        });
}

/**
 * 画像削除
 */
export const remove_image = (key) => {
    return Storage.remove(key, {
            level: "public"
        })
        .then(() => {
            return {
                result: true,
                data: null,
                message: 'ファイルを削除しました',
            }
        })
        .catch(err => {
            console.log(err);
            return {
                result: true,
                data: err,
                message: 'ファイルの削除に失敗しました',
            }
        });
}

/**
 * ファイル名のハッシュ化
 */
export const create_filename = (file) => {
    const ext = file.type.replace(/^image\//, "");
    const sha = crypto.createHash("sha1");
    sha.update(file.name);
    return sha.digest("hex") + "." + ext;
}
